// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
  font-family: "Open Sans", sans-serif;
  box-sizing: border-box;
}

.wrapper {
  max-height: 100%;
  position: relative;
  margin: 0;
  padding: 0;
}

.container {
  max-width: 100%;
  margin: 0 auto;
}

a {
  text-decoration: none;
}

.fade modal-backdrop show {
  width: 100%;
  height: 100%;
}

.modal-backdrop {
  width: 100% !important;
  height: 100% !important;
}

.card {
  width: 50%;
}
@media (max-width: 480px) {
  .card {
    width: 85%;
  }
}

th, td {
  font-size: 16px;
}
@media (max-width: 991px) {
  th, td {
    font-size: 12px;
  }
}

.table-container {
  overflow-x: auto;
}

.column {
  position: sticky;
  left: 0;
  top: 0;
  z-index: 1;
  background-color: white !important;
}

.column::after {
  content: "";
  position: absolute;
  top: 0;
  right: 0;
  width: 1px;
  height: 100%;
  background-color: #dee2e6;
}

.td_column {
  position: sticky;
  left: 0;
  top: 0;
  z-index: 3;
}
@media (max-width: 1024px) {
  .td_column {
    background-color: #ffffff !important;
  }
}

.td_column::after {
  content: "";
  position: absolute;
  top: 0;
  right: 0px;
  width: 1px;
  height: 100%;
  background-color: #dee2e6;
}

.custom-table {
  width: 50%;
  margin: 0 auto;
}

.show {
  font-size: 14px;
  font-weight: 400;
  color: #7d7f7d;
  text-align: center;
  cursor: pointer;
}

.border_bottom {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 1px;
  background-color: #dee2e6;
}

.border_top {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 1px;
  background-color: #dee2e6;
}

.btn-group, .btn-group-vertical {
  position: relative;
  display: block;
}`, "",{"version":3,"sources":["webpack://./src/app.scss"],"names":[],"mappings":"AAAA;EACI,oCAAA;EACA,sBAAA;AACJ;;AAGA;EACI,gBAAA;EACA,kBAAA;EACA,SAAA;EACA,UAAA;AAAJ;;AAKA;EACI,eAAA;EACA,cAAA;AAFJ;;AAKA;EACI,qBAAA;AAFJ;;AAKA;EACI,WAAA;EACA,YAAA;AAFJ;;AAMA;EACI,sBAAA;EACA,uBAAA;AAHJ;;AAMA;EACI,UAAA;AAHJ;AAIC;EAFD;IAGI,UAAA;EADF;AACF;;AAIA;EACI,eAAA;AADJ;AAGI;EAHJ;IAIQ,eAAA;EAAN;AACF;;AAKA;EACI,gBAAA;AAFJ;;AAOA;EACI,gBAAA;EACA,OAAA;EACA,MAAA;EACA,UAAA;EACA,kCAAA;AAJJ;;AAMA;EACI,WAAA;EACA,kBAAA;EACA,MAAA;EACA,QAAA;EACA,UAAA;EACA,YAAA;EACA,yBAAA;AAHJ;;AAOA;EACI,gBAAA;EACI,OAAA;EACA,MAAA;EACA,UAAA;AAJR;AAKQ;EALR;IAMY,oCAAA;EAFV;AACF;;AAKA;EACI,WAAA;EACA,kBAAA;EACA,MAAA;EACA,UAAA;EACA,UAAA;EACA,YAAA;EACA,yBAAA;AAFJ;;AAOA;EACI,UAAA;EACA,cAAA;AAJJ;;AAQA;EACQ,eAAA;EACA,gBAAA;EACA,cAAA;EACA,kBAAA;EACA,eAAA;AALR;;AASA;EACI,kBAAA;EACA,SAAA;EACA,OAAA;EACA,WAAA;EACA,WAAA;EACA,yBAAA;AANJ;;AASA;EACI,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,WAAA;EACA,yBAAA;AANJ;;AASA;EACI,kBAAA;EACA,cAAA;AANJ","sourcesContent":["* {\n    font-family: \"Open Sans\", sans-serif;\n    box-sizing: border-box;\n    \n}\n\n.wrapper {\n    max-height: 100%;\n    position: relative;\n    margin: 0;\n    padding: 0;\n    \n    \n}\n\n.container {\n    max-width: 100%;\n    margin: 0 auto;\n}\n\na {\n    text-decoration: none;\n}\n\n.fade modal-backdrop show {\n    width: 100%;\n    height: 100%;\n}\n\n\n.modal-backdrop {\n    width: 100% !important;\n    height: 100% !important;\n}\n\n.card {\n    width: 50%;\n @media(max-width: 480px) {\n    width: 85%;\n }\n}\n\nth, td {\n    font-size: 16px;\n    \n    @media (max-width: 991px) {\n        font-size: 12px;\n    }\n \n   \n}\n\n.table-container {\n    overflow-x: auto;\n}\n\n\n\n.column {\n    position: sticky;\n    left: 0;\n    top: 0;\n    z-index: 1;\n    background-color: white !important;\n}\n.column::after {\n    content: '';\n    position: absolute;\n    top: 0;\n    right: 0;\n    width: 1px;\n    height: 100%;\n    background-color: #dee2e6; \n    \n  }\n\n.td_column {\n    position: sticky;\n        left: 0;\n        top: 0;\n        z-index: 3;\n        @media(max-width: 1024px) {\n            background-color: #ffffff !important;\n        }\n       \n}\n.td_column::after {\n    content: '';\n    position: absolute;\n    top: 0;\n    right: 0px;\n    width: 1px;\n    height: 100%;\n    background-color: #dee2e6; \n    \n  }\n\n// projectInfo\n.custom-table {\n    width: 50%;\n    margin: 0 auto;\n}\n\n// Planning\n.show {\n        font-size: 14px;\n        font-weight: 400;\n        color: #7d7f7d;\n        text-align: center;\n        cursor: pointer;\n      \n}\n\n.border_bottom {\n    position: absolute;\n    bottom: 0;\n    left: 0;\n    width: 100%;\n    height: 1px;\n    background-color: #dee2e6;\n  }\n\n.border_top {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 1px;\n    background-color: #dee2e6;\n}\n\n.btn-group, .btn-group-vertical {\n    position: relative;\n    display: block ;\n    \n}\n\n\n\n\n\n\n\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
